import { cloneDeep } from 'lodash';
import {
  CreatePurchaseOrderPayload,
  PurchaseOrderDetails,
  PurchaseOrderFormValues,
  PurchaseOrderItem
} from './types';

export const createPurchaseOrderPayloadTransformer = (
  payload: CreatePurchaseOrderPayload
) => {
  const transformedPayloadClone = cloneDeep(payload);
  const newCleanPayload = {
    ...transformedPayloadClone,
    delivery_date: transformedPayloadClone?.delivery_date,
    po_date: transformedPayloadClone?.delivery_date,
    products: transformedPayloadClone?.products?.map((product) => ({
      product_id: product.product_id,
      dealer_price: product.dealer_price,
      quantity: product.quantity
    }))
  };
  return newCleanPayload;
};

export const getPurchaseOrderResponseFormikTransformer = (
  legitPayload: PurchaseOrderDetails
) => {
  const transformedData = {
    ...legitPayload,
    supplier_id: legitPayload?.supplier?.id,
    branch_id: legitPayload?.branch?.id || null,
    delivery_date: legitPayload?.delivery_date,
    po_date: legitPayload?.po_date,
    remarks: legitPayload?.remarks || '',
    products:
      legitPayload?.products?.map((product) => ({
        ...product,
        product_id: product.product_id,
        dealer_price: product.dealer_price,
        quantity: product.quantity,
        purchase_order_product_id: product.purchase_order_product_id,
        product_name: product.product_name
      })) || []
  };

  return transformedData;
};

export const dataCleanerForPurchaseOrderUpdate = (
  payload: PurchaseOrderFormValues & PurchaseOrderDetails
) => {
  const clonedPayload = cloneDeep(payload);
  delete clonedPayload.branch;
  delete clonedPayload.supplier;
  delete clonedPayload.total_amount;

  (clonedPayload?.products || [])?.forEach((product) => {
    delete product?.product_name;
  });

  return clonedPayload;
};

export const dataCleanerForPurchaseOrderProductsUpdate = (
  payload: PurchaseOrderItem[]
) => {
  const clonedPayload = cloneDeep(payload);
  const newCleanPayload = clonedPayload?.map((product) => {
    return {
      product_id: product?.product_id,
      dealer_price: product?.dealer_price,
      quantity: product?.quantity
    };
  });
  return newCleanPayload;
};

export const isPurchaseOrderProductValid = (
  product: PurchaseOrderItem,
  index: number
) => {
  console.log(product, index);

  if (!product || typeof product !== 'object') {
    return { valid: false, message: `Product  is not valid.` };
  }

  if (!product.product_id) {
    return {
      index,
      valid: false,
      message: `Product missing product_id.`
    };
  }

  if (!product.product_name || typeof product.product_name !== 'string') {
    return {
      index,
      valid: false,
      message: `Product missing product_name.`
    };
  }

  if (typeof product.quantity !== 'number' || product.quantity <= 0) {
    return {
      index,
      valid: false,
      message: `Product must have a quantity greater than 0.`
    };
  }

  return {
    index,
    valid: true
  };
};

export const findRemovedPurchaseOrderProductIds = (
  oldValue: PurchaseOrderItem[] = [],
  newValue: PurchaseOrderItem[] = []
) => {
  const oldIds = oldValue?.map((item) => item?.purchase_order_product_id);
  const newIds = newValue?.map((item) => item?.purchase_order_product_id);

  const removedIds = oldIds.filter((id) => !newIds.includes(id));
  return removedIds;
};
